/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Reminder_EveryInputs */

const en_us2_profile_reminder_every = /** @type {(inputs: Profile_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`every day`)
};

const pt_br2_profile_reminder_every = /** @type {(inputs: Profile_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`todos os dias`)
};

const es_419_profile_reminder_every = /** @type {(inputs: Profile_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`todos los días`)
};

const pt_pt2_profile_reminder_every = /** @type {(inputs: Profile_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`todos os dias`)
};

const fr_fr2_profile_reminder_every = /** @type {(inputs: Profile_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tous les jours`)
};

const de_de2_profile_reminder_every = /** @type {(inputs: Profile_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jeden Tag`)
};

const it_it2_profile_reminder_every = /** @type {(inputs: Profile_Reminder_EveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ogni giorno`)
};

/**
* | output |
* | --- |
* | "every day" |
*
* @param {Profile_Reminder_EveryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_reminder_every = /** @type {((inputs?: Profile_Reminder_EveryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Reminder_EveryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_reminder_every(inputs)
	if (locale === "es-419") return es_419_profile_reminder_every(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_reminder_every(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_reminder_every(inputs)
	if (locale === "de-DE") return de_de2_profile_reminder_every(inputs)
	if (locale === "it-IT") return it_it2_profile_reminder_every(inputs)
	return en_us2_profile_reminder_every(inputs)
});
export { profile_reminder_every as "profile.reminder_every" }